import { render } from "./MoreCard.vue?vue&type=template&id=2d1ba4cc&scoped=true"
import script from "./MoreCard.vue?vue&type=script&lang=js"
export * from "./MoreCard.vue?vue&type=script&lang=js"

import "./MoreCard.vue?vue&type=style&index=0&id=2d1ba4cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1ba4cc"]])

export default __exports__